import React from 'react';
import { motion } from 'motion/react';
import BrandLogo from '../BrandLogo';
import BrandBeatMark from './BrandBeatMark';
import AcesCredit from '../AcesCredit';
import { fadeUpVariants, pageVariants } from './authMotion';
import usePrefersReducedMotion from '../../hooks/usePrefersReducedMotion';

export default function AuthShell({
  children,
  title = 'Vitra',
  subtitle = 'Remote Patient Monitoring System for healthcare organizations.',
  showBeat = true,
}) {
  const reducedMotion = usePrefersReducedMotion();

  const pageMotion = reducedMotion
    ? { hidden: { opacity: 1 }, visible: { opacity: 1 } }
    : pageVariants;

  const itemMotion = reducedMotion
    ? { hidden: { opacity: 1 }, visible: { opacity: 1 } }
    : fadeUpVariants;

  return (
    <div className="flex min-h-screen flex-col lg:flex-row lg:items-stretch">
      <motion.aside
        variants={pageMotion}
        initial="hidden"
        animate="visible"
        className="relative flex w-full shrink-0 flex-col justify-between bg-[#0d9488] px-5 py-6 text-white sm:px-8 sm:py-8 lg:sticky lg:top-0 lg:h-screen lg:w-[42%] lg:max-w-[28rem] lg:px-12 lg:py-10 xl:max-w-[32rem]"
      >
        <motion.div
          variants={itemMotion}
          className="flex w-full shrink-0 items-center justify-between gap-3"
        >
          <BrandLogo
            asLink={false}
            variant="onDark"
            markClassName="h-9 w-9 sm:h-10 sm:w-10"
            wordmarkClassName="h-4 sm:h-5"
          />
          <AcesCredit variant="onDark" className="shrink-0" />
        </motion.div>

        <div className="my-6 flex min-h-0 flex-1 flex-col items-center justify-center text-center lg:my-0 lg:items-start lg:text-left">
          {showBeat && (
            <motion.div variants={itemMotion} className="mb-5 sm:mb-7">
              <BrandBeatMark size="h-28 w-28 sm:h-32 sm:w-32 lg:h-[9.75rem] lg:w-[9.75rem]" />
            </motion.div>
          )}

          <motion.p
            variants={itemMotion}
            className="text-xs font-semibold uppercase tracking-[0.18em] text-white/70 sm:text-sm"
          >
            {title}
          </motion.p>
          <motion.h1
            variants={itemMotion}
            className="mt-2 max-w-md text-2xl font-bold leading-tight tracking-tight sm:mt-3 sm:text-3xl lg:text-4xl"
          >
            Remote Patient Monitoring System
          </motion.h1>
          <motion.p
            variants={itemMotion}
            className="mt-3 max-w-md text-sm text-white/85 sm:mt-4 sm:text-base lg:text-lg"
          >
            {subtitle}
          </motion.p>
        </div>

        <motion.div variants={itemMotion} className="shrink-0">
          <p className="text-[11px] text-white/65 sm:text-xs lg:text-sm">
            © {new Date().getFullYear()} Vitra. All rights reserved.
          </p>
        </motion.div>
      </motion.aside>

      <section className="vitra-atmosphere relative flex w-full flex-1 items-start justify-center px-4 py-8 sm:px-6 sm:py-10 lg:min-h-screen lg:items-center lg:overflow-y-auto lg:px-8 lg:py-12">
        <div className="relative z-[1] w-full max-w-md">{children}</div>
      </section>
    </div>
  );
}
